import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { editQuestionnaire, mapSectionToPage } from 'Consts/Questionnaire';
import { questionnaireSectionNotes as enumeratedValuesQuestionnaireSectionNotes } from 'Consts/EnumeratedValues';
import EditButtonLink from 'Components/Blueprint/UI/EditButtonLink';

function getEditButton(simpleHousehold, strategy, isAgent) {
  if (strategy.type === 'questionnaireSectionNote') {
    const page = mapSectionToPage(strategy.attributes.sectionId);
    const link = editQuestionnaire(page, {
      isAgent,
      section: strategy.attributes.sectionId,
      householdId: simpleHousehold.householdResource.id(),
    });

    return (
      <EditButtonLink
        title="Edit Strategy"
        to={link}
      />
    );
  }

  return null;
}

const Strategies = ({ strategies, isAgent }) => {
  const simpleHousehold = useSimpleHousehold();

  return (
    <div className="strategies section">
      <div className="heading">
        <h4 className="bordered">Strategies</h4>
      </div>
      {strategies.length > 0 ? (
        <div className="color-bullets-list">
          {strategies.map((strategy, i) => (
            <div key={`${strategy.id}strat`} className="strategy">
              <div className="owner">
                <span className="number">{i + 1}</span>
                {strategy.meta.agent.firstName}
                &nbsp;
                {strategy.meta.agent.lastName}
                &nbsp;
                {moment(strategy.attributes.createdAt).format('MM/DD/YYYY')}
                {getEditButton(simpleHousehold, strategy, isAgent)}
              </div>
              <div className="content">
                {enumeratedValuesQuestionnaireSectionNotes(
                  'section',
                  strategy.attributes.sectionId,
                ).toUpperCase()}
                &nbsp;&middot;&nbsp;
                {strategy.attributes.content}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div>No strategies.</div>
      )}
    </div>
  );
};

Strategies.propTypes = {
  strategies: PropTypes.array.isRequired,
  isAgent: PropTypes.bool.isRequired,
};

export default Strategies;
